import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const LoanDetailsList = () => {
  const [loans, setLoans] = useState([]);
  const token = sessionStorage.getItem("authToken");
  const navigate = useNavigate();

  const fetchLoans = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getLoanDetails`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoans(res.data.data || []);
    } catch (err) {
      console.error("Error fetching loan details:", err);
    }
  };

  useEffect(() => {
    fetchLoans();
  }, []);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Loan Details List</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 text-sm">
            <thead className="bg-gray-200">
              <tr>
                <th className="border px-4 py-2">ID</th>
                <th className="border px-4 py-2">Loan ID</th>
                <th className="border px-4 py-2">Main Title</th>
                <th className="border px-4 py-2">Main Sub Title</th>
                <th className="border px-4 py-2">Home Desc</th>
                <th className="border px-4 py-2">Loan Desc</th>
                <th className="border px-4 py-2">Main Desc</th>
                <th className="border px-4 py-2">Loan Img</th>
                <th className="border px-4 py-2">Main Img</th>
                <th className="border px-4 py-2">SEO Title</th>
                <th className="border px-4 py-2">SEO Desc</th>
                <th className="border px-4 py-2">SEO Tag</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loans.map((loan) => (
                <tr key={loan.id} className="hover:bg-gray-50">
                  <td className="border px-4 py-2">{loan.id}</td>
                  <td className="border px-4 py-2">{loan.loan_id}</td>
                  <td className="border px-4 py-2">{loan.main_title}</td>
                  <td className="border px-4 py-2">{loan.main_sub_title}</td>
                  <td className="border px-4 py-2 truncate max-w-xs">{loan.home_desc}</td>
                  <td className="border px-4 py-2 truncate max-w-xs">{loan.loan_desc}</td>
                  <td className="border px-4 py-2 truncate max-w-xs">{loan.main_desc}</td>
                  <td className="border px-4 py-2">
                    {loan.loan_img && (
                      <img
                        src={`${COMMON_API}/ImgUploads/${loan.loan_img}`}
                        alt="Loan Img"
                        className="w-16 h-12 object-cover rounded"
                      />
                    )}
                  </td>
                  <td className="border px-4 py-2">
                    {loan.main_img && (
                      <img
                        src={`${COMMON_API}/ImgUploads/${loan.main_img}`}
                        alt="Main Img"
                        className="w-16 h-12 object-cover rounded"
                      />
                    )}
                  </td>
                  <td className="border px-4 py-2 truncate max-w-xs">{loan.seo_title}</td>
                  <td className="border px-4 py-2 truncate max-w-xs">{loan.seo_desc}</td>
                  <td className="border px-4 py-2 truncate max-w-xs">{loan.seo_tag}</td>
                  <td className="border px-4 py-2">
                    <button
                      onClick={() => navigate(`/edit-loan-details/${loan.id}`)}
                      className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
              {loans.length === 0 && (
                <tr>
                  <td colSpan="12" className="text-center py-3 text-gray-500">
                    No loan details found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LoanDetailsList;
